import React, { Component } from 'react';
import { MdClose, MdStarBorder } from 'react-icons/md';

import A from '../../../shared/Anchor/Anchor';
import Price from '../../../shared/Price/Price';
import CartQuantity from '../../../shared/CartQuantity/CartQuantity';

import { primary_s5_l60 } from '../../../shared/lib/colors';

import { jsx, css } from '@emotion/core';

import './ProdottoCarrello.scss';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';

class ProdottoCarrello extends Component {
  renderSubtotal() {
    let { product } = this.props;

    return product.price * product.quantity;
  }

  render() {
    let {
      product,
      onIncrement,
      onDecrement,
      onRemove,
      primaryColor,
      uiVariantButton,
    } = this.props;

    const productStyle = css`
      .icona-ricetta {
        fill: ${primaryColor};
      }
    `;

    return (
      <div className="prodotto-carrello">
        <div className="info-container">
          <div className="img-name-container">
            <div
              className="img-box"
              style={{
                borderRadius:
                  uiVariantButton === '1'
                    ? '12px'
                    : uiVariantButton === '3'
                    ? '6px'
                    : 0,
              }}
            >
              <div
                className="img-container"
                style={{ backgroundImage: `url(${product.image})` }}
                title={product.name}
              />
            </div>
            <div className="name">
              <span
                className="span-name"
                style={{
                  color: product.availableLessThanRequested ? '#c00' : '',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {!!product.prescription && (
                  <div className="pad-left">
                    <ImageDispatcher
                      className="icona-ricetta"
                      src="/static/images/icona-ricetta.svg"
                      style={{ height: 32, width: 32 }}
                    />
                  </div>
                )}
                <div
                  className="pad-left"
                  style={{ display: 'flex', flexDirection: 'column' }}
                >
                  {!!product.isFreeCorrelatedProduct && (
                    <div
                      style={{
                        fontSize: 12,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                      }}
                    >
                      <MdStarBorder
                        color="black"
                        style={{ width: 16, height: 16 }}
                      />
                      In omaggio!
                    </div>
                  )}
                  {product.name}
                </div>
              </span>
            </div>
          </div>
          <div
            className="price-quantity-container"
            style={product.availableLessThanRequested ? { color: '#c00' } : {}}
          >
            <div className="price">
              {!!product.listPrice && product.listPrice > product.price && (
                <span
                  className="prev-price"
                  style={{ color: primary_s5_l60(primaryColor) }}
                >
                  <Price amount={product.listPrice} />
                </span>
              )}
              <Price amount={product.price} />
            </div>
            <div className="quantity-small">
              <CartQuantity
                productName={product.name}
                disabled={!!product.isFreeCorrelatedProduct}
                value={product.quantity}
                availableLessThanRequested={
                  product.availableLessThanRequested ||
                  product.quantity < product.minNumInCart
                }
                onIncrement={onIncrement}
                onDecrement={onDecrement}
                uiVariantButton={uiVariantButton}
              />
              {product.minNumInCart && (
                <span className="min-in-cart">
                  Quantità min. {product.minNumInCart}
                </span>
              )}
            </div>
            <div className="quantity-big">
              <CartQuantity
                productName={product.name}
                disabled={!!product.isFreeCorrelatedProduct}
                value={product.quantity}
                availableLessThanRequested={
                  product.availableLessThanRequested ||
                  product.quantity < product.minNumInCart
                }
                onIncrement={onIncrement}
                onDecrement={onDecrement}
                isBig
                uiVariantButton={uiVariantButton}
              />
              {product.minNumInCart && (
                <span className="min-in-cart">
                  Quantità min. {product.minNumInCart}
                </span>
              )}
            </div>
          </div>
          <div className="subtotal-container">
            <span className="text">Subtotale</span>
            <Price amount={this.renderSubtotal()} />
          </div>
        </div>
        <div className="remove-container">
          <A href="#" onClick={onRemove}>
            <MdClose />
          </A>
        </div>
      </div>
    );
  }
}

export default ProdottoCarrello;
